import { createApiHandler } from './handler';

const ranges = {
  apiClient: null,
  path: '/franchises/local-delivery-ranges',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default ranges;
